/* eslint-disable no-alert, no-console */
/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import fetch from "utils/api-client-wrapper";
import type { PutV1UsersUserSettingsMutationRequest, PutV1UsersUserSettingsMutationResponse, PutV1UsersUserSettings422 } from "../../../types/PutV1UsersUserSettings.ts";
import type { Client, RequestConfig, ResponseErrorConfig } from "utils/api-client-wrapper";

function getPutV1UsersUserSettingsUrlClient() {
  const res = { method: 'PUT', url: `/v1/users/user_settings` as const }
  return res
}

/**
 * @summary Update user settings
 * {@link /v1/users/user_settings}
 */
export async function putV1UsersUserSettingsClient(data: PutV1UsersUserSettingsMutationRequest, config: Partial<RequestConfig<PutV1UsersUserSettingsMutationRequest>> & { client?: Client } = {}) {
  const { client: request = fetch, ...requestConfig } = config

  const requestData = data

  const res = await request<PutV1UsersUserSettingsMutationResponse, ResponseErrorConfig<PutV1UsersUserSettings422>, PutV1UsersUserSettingsMutationRequest>({ method : "PUT", url : getPutV1UsersUserSettingsUrlClient().url.toString(), data : requestData, ... requestConfig })
  return res
}